(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nomadic-header"]) return;
  try {
    
  const nomadicHeaderGroup = document.querySelector('#header-group');
  if (nomadicHeaderGroup && !nomadicHeaderGroup.dataset.nomadicObserved) {
    nomadicHeaderGroup.dataset.nomadicObserved = 'true';
    const updateNomadicHeader = () => {
      const total = nomadicHeaderGroup.getBoundingClientRect().height;
      document.body.style.setProperty('--header-group-height', `${total}px`);
      document.body.style.setProperty('--header-height', `${nomadicHeaderGroup.querySelector('.nk-header')?.getBoundingClientRect().height || total}px`);
    };
    new ResizeObserver(updateNomadicHeader).observe(nomadicHeaderGroup);
    updateNomadicHeader();
  }
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.nk-mobile-menu[open], .nk-submenu[open]').forEach((menu) => {
      if (!menu.contains(event.target) || event.target.closest('a')) menu.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.nk-mobile-menu[open], .nk-submenu[open]').forEach((menu) => {
      menu.removeAttribute('open');
      menu.querySelector('summary').focus();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nomadic-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nomadic-hero-video')) {
    customElements.define('nomadic-hero-video', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const video = this.querySelector('video');
        const button = this.querySelector('button');
        if (!video || !button) return;
        const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        video.muted = true;
        video.playsInline = true;
        button.hidden = false;
        const update = () => {
          button.setAttribute('aria-label', video.paused ? button.dataset.play : button.dataset.pause);
          button.querySelector('.nk-toggle-play').hidden = !video.paused;
          button.querySelector('.nk-toggle-pause').hidden = video.paused;
        };
        const play = () => video.play().catch(update);
        button.addEventListener('click', () => video.paused ? play() : video.pause());
        video.addEventListener('play', update);
        video.addEventListener('pause', update);
        this.stopForMotion = () => { if (motion.matches) video.pause(); };
        motion.addEventListener('change', this.stopForMotion);
        this.motion = motion;
        if (!motion.matches) play();
        update();
      }
      disconnectedCallback() { this.motion?.removeEventListener('change', this.stopForMotion); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nomadic-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nomadic-video')) {
    customElements.define('nomadic-video', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const poster = this.querySelector('[data-video-id]');
        if (!poster) return;
        poster.addEventListener('click', (event) => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const id = poster.dataset.videoId;
          if (!/^[a-zA-Z0-9_-]{11}$/.test(id)) return;
          event.preventDefault();
          const frame = document.createElement('iframe');
          frame.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
          frame.title = poster.dataset.videoTitle;
          frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
          frame.allowFullscreen = true;
          frame.referrerPolicy = 'strict-origin-when-cross-origin';
          this.replaceChildren(frame);
          frame.focus();
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
